export namespace MtoConstants {
  export enum MtoComponentPricingLogic {
    LINK_OVERRIDE = "LINK_OVERRIDE",
    CHILD_TREATMENT = "CHILD_TREATMENT",
    AMOUNT_HIGHEST = "AMOUNT_HIGHEST",
    TIERED_PRICING = "TIERED_PRICING",
    DEFAULT_PRICING_SCHEME = "DEFAULT_PRICING_SCHEME"
  }
}